import {DateTime} from 'luxon';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';

export function propertyOf<T>(property: keyof T): keyof T {
  return property
}

export const numberFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

export function getLocalDateTimeString(dateTime: string)  {
  return DateTime.fromISO(dateTime.replace(' ', 'T') + '+00:00').toLocaleString(DateTime.DATETIME_MED);
}

export const currencyMask = createNumberMask({
  prefix: '$',
  suffix: '',
  allowDecimal: true
});



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/utils.ts